import { notification } from 'antd';
import { fabric } from 'fabric';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIndex } from '../../../fabric_obj/container';
import { deleteControl, deleteLabel } from '../../../fabric_obj/lineControl';
import { cleanObject, highlightObjId, turnOffHighLightPolyline } from '../../../fabric_obj/utils';
import { actions } from '../../../redux';
import { setActiveType } from '../../../redux/board/reducer';
import {
  ACTIVE_SELECTION,
  BUS_EVENTS,
  CANVAS_ACTION,
  CHART,
  CUSTOM_GROUP_ID,
  eventBus,
  EVENT_TYPE,
  FABRIC_CUSTOM_OBJECT,
  generateId,
  getCurrentState,
  getObjId,
  getSettingsUpdateFromBackgroundImage,
  htmlImagePropertiesToInclude,
  IMAGE_HTML_TYPE,
  isEdgeOfPage,
  ITEXT,
  KEYS_CODE,
  propertiesToInclude,
  reRenderTextTypeList,
  resetViewCanvas,
  SUBTYPE_TEXT_COMPONENT,
  TEXTBOX,
  TEXT_GROUP_ID,
  ungroup,
} from '../../../utils';
import {
  convertBoxCheckListToSvg,
  convertBreadcrumbToSvg,
  convertBulletListToSvg,
  convertCalendarToSvg,
  convertLinkBarToSvg,
  convertMenuBarToSvg,
  convertRadiusCheckListToSvg,
  convertRatingToSvg,
  convertStepNavToSvg,
  convertTableToSvg,
  convertTreeListToSvg,
} from '../helper/htmlComponent';

import { convertChartToSvg } from '../helper/chartComponent';
import { setIsContentChange } from '../../../redux/stateManager/reducer';

let clipboard;
const offset = 20;

export default () => {
  const dispatch = useDispatch();
  const layerAction = useSelector((appState) => appState.board.layerAction);
  const searching = useSelector((appState) => appState.board.searching);
  const ignoreKeyCodeEvent = useSelector((appState) => appState.board.ignoreKeyCodeEvent);
  const undoStageLength = useSelector((appState) => appState.stateManager.stateStack.length);
  const redoStageLength = useSelector((appState) => appState.stateManager.redoStack.length);
  const addComponentLoading = useSelector((Appstate) => Appstate.canvas.addComponentLoading);
  const [state, _setState] = useState({
    canvas: null,
    isEdit: false,
    editPosition: { top: 0, left: 0 },
    menuPosition: {},
    editorInformation: {},
    isShowMenu: false,
    isShowEditor: false,
    isShowAddModal: false,
    isSaveSystemComponent: false,
    isSaveDiagramComponent: false,
    isShowChartEdit: false,
  });
  const setContextState = (obj) => _setState((_state) => ({ ..._state, ...obj }));
  const saveState = () => {
    eventBus.emit('save-canvas-state');
  };

  const handleContextLayer = (data) => {
    setContextState({ menuPosition: {} });
    dispatch(actions.setLayerAction(data));
  };
  const handleLayerForPolyline = (polyline, action) => {
    const objLength = window.canvas.getObjects().length;
    const indexPolyline = getIndex(polyline);
    let indexForward = objLength - 1;
    let indexBackward = 0;
    window.canvas.getObjects().forEach((o, index) => {
      if (!o.isNotObj && o.name !== 'highlightPolyline' && o.name !== 'highlightLabel' && o.name !== 'Label') {
        if (index > indexPolyline) indexForward = Math.min(index, indexForward);
        if (index < indexPolyline) indexBackward = Math.max(index, indexBackward);
      }
    });
    switch (action) {
      case 'sendBackwards':
        window.canvas.moveTo(polyline, indexBackward);
        break;
      case 'sendToBack':
        polyline.sendToBack();
        break;
      case 'bringForward':
        window.canvas.moveTo(polyline, indexForward);
        break;
      case 'bringToFront':
        polyline.bringToFront();
        break;
      default:
        break;
    }
    let index = getIndex(polyline);
    window.canvas.getObjects().forEach((o) => {
      if (o.name === 'highlightPolyline' || o.name === 'highlightLabel')
        window.canvas.moveTo(o, Math.max(index - 1, 0));
    });
    [...window.canvas.getObjects()].reverse().forEach((o) => {
      index = getIndex(polyline);
      if (o?.polylineId === polyline.id && o.name === FABRIC_CUSTOM_OBJECT.label) window.canvas.moveTo(o, index);
    });

    state.canvas.renderAll();
    window.canvas.renderAll();
  };
  const handleLayer = (obj, action) => {
    if (obj?.type === FABRIC_CUSTOM_OBJECT.polyline) {
      handleLayerForPolyline(obj, action);
      return;
    }
    switch (action) {
      case 'sendBackwards':
        obj.sendBackwards(false);
        break;
      case 'sendToBack':
        obj.sendToBack();
        break;
      case 'bringForward':
        obj.bringForward(false);
        break;
      case 'bringToFront':
        obj.bringToFront();
        break;
      default:
        break;
    }

    state.canvas.renderAll();
    window.canvas.renderAll();
  };
  const handleLayerBtn = (action) => {
    const obj = window.canvas.getActiveObject();
    handleLayer(obj, action);
  };
  const discardSelectedObject = () => {
    window.canvas.discardActiveObject();
    dispatch(setActiveType(null));
    window.canvas.renderAll();
  };
  const removeObjects = () => {
    const objs = window.canvas.getActiveObjects();

    if (!objs?.length) return;
    cleanObject();
    saveState();
    objs.forEach((obj) => {
      if (obj.type === FABRIC_CUSTOM_OBJECT.polyline) {
        deleteControl();
        deleteLabel(obj.id);
        if (highlightObjId.id === obj.id) turnOffHighLightPolyline();
      }
      window.canvas.remove(obj);
    });
    discardSelectedObject();
    dispatch(setIsContentChange(true));
  };
  const applyState = (newState) => {
    window.canvas.loadFromJSON(newState, () => {
      const settingUpdate = getSettingsUpdateFromBackgroundImage(window.canvas);
      dispatch(actions.editPageSettings(settingUpdate));
      window.canvas.requestRenderAll();
      reRenderTextTypeList(window.canvas);
    });
  };
  const undo = () => {
    if (undoStageLength <= 1) return;
    const currState = getCurrentState();
    dispatch(actions.undoSaga({ currState, applyState }));
  };
  const redo = () => {
    if (!redoStageLength) return;
    const currState = getCurrentState();
    dispatch(actions.redoSaga({ currState, applyState }));
  };

  const copyObjects = () => {
    const obj = window.canvas.getActiveObject();
    if (obj) {
      obj.clone((cloned) => {
        clipboard = cloned;
        eventBus.emit(CANVAS_ACTION.COPY_SUCCESS);
      }, propertiesToInclude);
    }
  };

  const pasteObjects = (x = null, y = null) => {
    if (clipboard) {
      saveState();
      clipboard.clone((clonedObj) => {
        window.canvas.discardActiveObject();
        clonedObj.set({
          left: x || clonedObj.left + 10,
          top: y || clonedObj.top + 10,
          evented: true,
        });
        if (clonedObj.type === ACTIVE_SELECTION) {
          clonedObj.canvas = window.canvas;
          clonedObj.forEachObject((obj) => {
            getObjId(obj);
            window.canvas.add(obj);
          });
          clonedObj.setCoords();
        } else {
          getObjId(clonedObj);
          window.canvas.add(clonedObj);
        }
        clipboard.top += 10;
        clipboard.left += 10;
        window.canvas.setActiveObject(clonedObj);
        window.canvas.renderAll();
        dispatch(setIsContentChange(true));

        eventBus.emit('reload-oldTree', clonedObj);
      }, propertiesToInclude);
    }
  };
  const selectAll = () => {
    window.canvas.discardActiveObject();
    const sel = new fabric.ActiveSelection(
      window.canvas.getObjects().filter((o) => !isEdgeOfPage(o)),
      {
        canvas: window.canvas,
      },
    );
    window.canvas.setActiveObject(sel);
    window.canvas.requestRenderAll();
  };
  const keyCodeEvents = (e) => {
    console.log('---keycode---event---layerHooks-----');
    if (state.isEdit || state.isShowAddModal || state.isShowEditor || searching || ignoreKeyCodeEvent) {
      return;
    }
    switch (e.keyCode) {
      case KEYS_CODE.DELETE:
      case KEYS_CODE.BACKSPACE:
        removeObjects();
        eventBus.emit('regroup');
        break;
      case KEYS_CODE.ESCAPE:
        discardSelectedObject();
        break;
      default:
        break;
    }
    if (e.altKey) {
      switch (e.keyCode) {
        case KEYS_CODE.R:
          resetViewCanvas();
          break;
        case KEYS_CODE.D:
          eventBus.emit(CANVAS_ACTION.DRAWING);
          break;
        case KEYS_CODE.S:
          eventBus.emit(CANVAS_ACTION.SHARE_PROJECT);
          break;
        default:
          break;
      }
    }
    if ((e.ctrlKey || e.metaKey) && !e.shiftKey) {
      switch (e.keyCode) {
        case KEYS_CODE.A:
          selectAll();
          if (e.preventDefault) {
            e.preventDefault();
          }
          if (e.stopPropagation) {
            e.stopPropagation();
          }
          break;
        case KEYS_CODE.Z:
          undo();
          if (e.preventDefault) {
            e.preventDefault();
          }
          if (e.stopPropagation) {
            e.stopPropagation();
          }
          break;
        case KEYS_CODE.Y:
          redo();
          if (e.preventDefault) {
            e.preventDefault();
          }
          if (e.stopPropagation) {
            e.stopPropagation();
          }
          break;
        case KEYS_CODE.C:
          copyObjects();
          break;
        case KEYS_CODE.D:
          copyObjects();
          pasteObjects();
          if (e.preventDefault) {
            e.preventDefault();
          }
          if (e.stopPropagation) {
            e.stopPropagation();
          }
          break;
        case KEYS_CODE.E:
          eventBus.emit(CANVAS_ACTION.EXPORT_PNG);
          break;
        case KEYS_CODE.X:
          copyObjects();
          removeObjects();
          break;
        case KEYS_CODE.V:
          pasteObjects();
          break;
        case KEYS_CODE.ARROW_UP:
          dispatch(actions.setLayerAction('bringForward'));
          break;
        case KEYS_CODE.ARROW_DOWN:
          dispatch(actions.setLayerAction('sendBackwards'));
          break;
        default:
          break;
      }
    }
    if ((e.metaKey || e.ctrlKey) && e.shiftKey) {
      switch (e.keyCode) {
        case KEYS_CODE.ARROW_UP:
          dispatch(actions.setLayerAction('bringToFront'));
          break;
        case KEYS_CODE.ARROW_DOWN:
          dispatch(actions.setLayerAction('sendToBack'));
          break;
        default:
          break;
      }
    }
    // if (e.preventDefault) {
    //   e.preventDefault();
    // }
    // if (e.stopPropagation) {
    //   e.stopPropagation();
    // }
  };
  const handlePasteHere = () => {
    pasteObjects(state.menuPosition.x, state.menuPosition.y);
  };
  const handleUngroup = () => {
    const { canvas } = window;
    const obj = canvas.getActiveObject();
    if (!obj) return;
    const { id } = obj;
    if (!id || !id.includes(CUSTOM_GROUP_ID)) return;
    ungroup(obj, canvas, true);
  };

  const createTextComponent = () => {
    const { canvas } = window;
    const objs = canvas.getActiveObject();
    if (!objs) {
      notification.info({
        message: 'Select components to create.',
      });
      return;
    }
    const items = objs.getObjects();
    const textComponent = items.find((o) => [TEXTBOX, ITEXT].includes(o.type));
    if (!textComponent) {
      notification.info({
        message: 'Select at least 1 text component.',
      });
      return;
    }
    const obj = items.find((o) => ![TEXTBOX, ITEXT].includes(o.type));
    if (!obj) {
      notification.info({
        message: 'Support just 1 text component.',
      });
      return;
    }
    textComponent.set({
      width: obj.getScaledWidth() - offset,
    });
    textComponent.setCoords();
    const groupId = `${generateId()}_${TEXT_GROUP_ID}`;
    items.forEach((o) => {
      o.set({ parentId: groupId });
    });
    const newGroup = objs.toGroup();
    newGroup.set({
      id: groupId,
      name: 'text_custom_group',
      subType: SUBTYPE_TEXT_COMPONENT,
      colorSetting: true,
      objectCaching: false,
    });

    canvas.renderAll();
  };
  const addGroup = () => {
    const { canvas } = window;
    const activeObjs = canvas.getActiveObject();
    if (!activeObjs) {
      return;
    }
    if (activeObjs.type !== ACTIVE_SELECTION) {
      return;
    }
    activeObjs.set({
      id: null,
    });
    const groupId = `${generateId()}_${CUSTOM_GROUP_ID}`;
    activeObjs.getObjects().forEach((o) => {
      o.set({ parentId: groupId });
    });
    const newGroup = activeObjs.toGroup();
    newGroup.set({
      id: groupId,
      name: 'user_custom_group',
    });
    canvas.requestRenderAll();
  };
  const handleContextMenu = (data) => {
    const { type } = data;
    // const obj = window.canvas.getActiveObject();
    switch (type) {
      case EVENT_TYPE.new_component:
        addGroup();
        break;
      case EVENT_TYPE.key_code:
        keyCodeEvents(data);
        break;
      case EVENT_TYPE.new_text_component:
        createTextComponent();
        break;
      case EVENT_TYPE.paste_here:
        handlePasteHere();
        break;
      case EVENT_TYPE.un_group:
        // handle Un Group
        handleUngroup();
        break;
      default:
        break;
    }
    setContextState({ menuPosition: {}, isShowMenu: false });
  };
  const onSearchComponent = () => {
    discardSelectedObject();
  };
  useEffect(() => {
    eventBus.on(CANVAS_ACTION.UNDO, undo);
    eventBus.on(CANVAS_ACTION.REDO, redo);
    eventBus.on(CANVAS_ACTION.COPY, copyObjects);

    return () => {
      eventBus.off(CANVAS_ACTION.UNDO, undo);
      eventBus.off(CANVAS_ACTION.REDO, redo);
      eventBus.off(CANVAS_ACTION.COPY, copyObjects);
    };
  }, [undoStageLength, redoStageLength]);
  useEffect(() => {
    if (layerAction) {
      const { canvas } = window;
      const activeObj = canvas.getActiveObject();
      if (!activeObj) return;
      handleLayer(activeObj, layerAction);
    }
  }, [layerAction]);
  useEffect(() => {
    if (!addComponentLoading) {
      setContextState({ isShowAddModal: false });
    }
  }, [addComponentLoading]);

  const convertEditorDataToSvg = (data, id, options) => {
    if (`${id}`.includes(IMAGE_HTML_TYPE.radiusCheck)) return convertRadiusCheckListToSvg(data);
    if (`${id}`.includes(IMAGE_HTML_TYPE.table)) return convertTableToSvg(data);
    if (`${id}`.includes(IMAGE_HTML_TYPE.boxCheck)) return convertBoxCheckListToSvg(data);
    if (`${id}`.includes(IMAGE_HTML_TYPE.bulletList)) return convertBulletListToSvg(data);
    if (`${id}`.includes(IMAGE_HTML_TYPE.treeList)) return convertTreeListToSvg(data);
    if (`${id}`.includes(IMAGE_HTML_TYPE.linkBar)) return convertLinkBarToSvg(data);
    if (`${id}`.includes(IMAGE_HTML_TYPE.breadcrumb)) return convertBreadcrumbToSvg(data);
    if (`${id}`.includes(IMAGE_HTML_TYPE.stepNav)) return convertStepNavToSvg(data);
    if (`${id}`.includes(IMAGE_HTML_TYPE.rating)) return convertRatingToSvg(data);
    if (`${id}`.includes(IMAGE_HTML_TYPE.calendar)) return convertCalendarToSvg(data);
    if (`${id}`.includes(IMAGE_HTML_TYPE.menuBar)) return convertMenuBarToSvg(data);

    if (`${id}`.includes(IMAGE_HTML_TYPE.chart)) return convertChartToSvg(options);

    return { svg: null, width: null, height: null };
  };

  const handleCloseEditor = () => {
    setContextState({ editorInformation: {}, isShowEditor: false });
  };

  const onUpdateHtmlComponent = (c) => {
    const { data, id, options = {} } = c;
    const { svg, width, height } = convertEditorDataToSvg(data, id, options);
    if (!svg) setContextState({ editorInformation: {}, isShowEditor: false });

    const item = window.canvas.getObjects().find((e) => e.id === id);

    const newData = {};
    if (!item) return;
    Object.keys(item).forEach((key) => {
      if (htmlImagePropertiesToInclude.includes(key)) newData[key] = item[key];
    });
    const modifiedSvg = svg.replace(/&/g, '&amp;');
    let dataUri = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(modifiedSvg)))}`;
    if (id.includes(CHART)) dataUri = svg;
    fabric.Image.fromURL(
      dataUri,
      (myImg) => {
        window.canvas.add(myImg);
        if (id.includes(CHART)) window.canvas.setActiveObject(myImg);
        window.canvas.remove(item);
        dispatch(actions.updatePageContent(getCurrentState()));
        window.canvas.renderAll();
      },
      {
        ...newData,
        htmlContent: data,
        width,
        height,
      },
    );
    if (!id.includes(CHART)) setContextState({ editorInformation: {}, isShowEditor: false });
    else {
      setContextState({ editorInformation: { ...state.editorInformation, data, objectId: id } });
      eventBus.emit(BUS_EVENTS.UPDATE_CHART_OBJECT, { data, id });
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', keyCodeEvents);
    eventBus.on('on-search-component', onSearchComponent);

    eventBus.on('handle-context-menu', handleContextMenu);
    eventBus.on('handle-layer-context', handleContextLayer);
    eventBus.on('on-change-layer', handleLayerBtn);

    // eventBus.on('submit-editor-data', handleEditorData);
    eventBus.on('close-editor', handleCloseEditor);

    return () => {
      eventBus.off('handle-context-menu', handleContextMenu);
      eventBus.off('handle-layer-context', handleContextLayer);
      eventBus.off('on-change-layer', handleLayerBtn);
      document.removeEventListener('keydown', keyCodeEvents);
      eventBus.off('on-search-component', onSearchComponent);

      // eventBus.off('submit-editor-data', handleEditorData);
      eventBus.off('close-editor', handleCloseEditor);
    };
  }, [
    state.editorInformation,
    state.isEdit,
    state.isShowAddModal,
    searching,
    ignoreKeyCodeEvent,
    state.menuPosition,
    state.isSaveSystemComponent,
    state.isSaveDiagramComponent,
    undoStageLength,
    redoStageLength,
  ]);

  const initCanvas = (canvas) => _setState({ canvas });
  const getContextState = () => ({
    menuPosition: state.menuPosition,
    editorInformation: state.editorInformation,
    isShowEditor: state.isShowEditor,
    editPosition: state.editPosition,
    isShowMenu: state.isShowMenu,
    isShowAddModal: state.isShowAddModal,
    isEdit: state.isEdit,
    isSaveSystemComponent: state.isSaveSystemComponent,
    isSaveDiagramComponent: state.isSaveDiagramComponent,
  });
  return {
    initCanvas,
    contextState: getContextState(),
    setContextState,
    onUpdateHtmlComponent,
  };
};
